<template>
    <div class="w-full">
        <div class="bg-grey-light text-grey-darkest py-2 px-3 justify-between">
            <span>Logs</span>
        </div>

        <div v-if="activities.length > 0" v-for="(log, index) in activities">
            <div v-if="log.description.length > 0"
                 class="px-3 flex-col text-grey-darkest border-b-1 py-3 hover:bg-grey-lighter" :key="`log-${index}`">
                <div class="flex flex-wrap flex-md-nowrap md:justify-between text-sm mb-2">
                    <div class="flex flex-wrap flex-md-nowrap">
                        <div class="mr-4 w-full md:w-auto">{{ (log.created_at) ? createdTime(log.created_at) : ''  }}</div>
                        <div class="w-full md:w-auto"><span>{{ log.type }}</span></div>
                    </div>
                    <div class="w-full md:w-auto">
                        <span>Created by: </span><span class="text-grey-darkest font-medium">{{ log.creator }}</span>
                    </div>
                </div>
                <div class="flex justify-between">
                    <div class="leading-tight md:mr-32 text-grey-darkest">
                        <div v-html="log.description"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['project'],
        data() {
            return {
                activities: []
            }
        },
        created() {
            axios.get('/project/logs?project_id=' + this.project.id)
                .then((response) => {
                    this.activities = response.data.data;
                });
        },
        methods: {
            createdTime(createdTime){
                return moment.utc(createdTime).local().format('MM/DD/YYYY hh:mm A')
            }
        }
    }
</script>
